import { getActiveLanguages } from '../apis/languages';
import i18n from './i18n';

/**
 * Khởi tạo ngôn ngữ mặc định từ API
 * Load ngôn ngữ đã lưu nếu có, nếu không thì load ngôn ngữ default từ API
 * @returns {Promise<Object>} - Trả về object ngôn ngữ được chọn
 */
export const initializeLanguageFromAPI = async () => {
  try {
    const response = await getActiveLanguages();

    // Xử lý nhiều format response khác nhau
    let listLang = null;

    if (response.success && response.data && Array.isArray(response.data)) {
      listLang = response.data;
    } else if (Array.isArray(response)) {
      // Nếu response là array trực tiếp
      listLang = response;
    } else if (response.data && Array.isArray(response.data)) {
      // Nếu response có data field
      listLang = response.data;
    }

    if (listLang && listLang.length > 0) {
      console.log("Các ngôn ngữ từ API:", listLang);

      // Kiểm tra xem user đã chọn ngôn ngữ trước đó chưa
      const savedLanguageCode = localStorage.getItem('selectedLanguageCode');
      let selectedLanguage;

      if (savedLanguageCode) {
        // Nếu có ngôn ngữ đã lưu, sử dụng nó
        selectedLanguage = listLang.find(l => l.code === savedLanguageCode);
        if (!selectedLanguage) {
          // Nếu ngôn ngữ đã lưu không tồn tại trong API, dùng default
          selectedLanguage = listLang.find(l => l.isDefault === 1 || l.isDefault === true) || listLang[0];
        }
      } else {
        // Nếu không có ngôn ngữ đã lưu, sử dụng ngôn ngữ mặc định từ API
        selectedLanguage = listLang.find(l => l.isDefault === 1 || l.isDefault === true) || listLang[0];
      }

      console.log("Ngôn ngữ được chọn:", selectedLanguage);

      // Cập nhật fallbackLng trong i18n với ngôn ngữ mặc định từ API
      i18n.options.fallbackLng = selectedLanguage.code;

      // Thay đổi ngôn ngữ hiện tại nếu chưa được set
      if (i18n.language !== selectedLanguage.code) {
        await i18n.changeLanguage(selectedLanguage.code);
      }

      // Lưu ngôn ngữ hiện tại vào localStorage
      localStorage.setItem('selectedLanguageCode', selectedLanguage.code);

      return selectedLanguage;
    } else {
      console.warn('Không có dữ liệu ngôn ngữ từ API, sử dụng mặc định (vi). Response:', response);
      localStorage.setItem('selectedLanguageCode', 'vi');
      return { code: 'vi', name: 'Vietnamese', isDefault: true };
    }
  } catch (error) {
    console.error('Lỗi khởi tạo ngôn ngữ từ API:', error);
    console.error('Chi tiết lỗi:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      url: error.config?.url
    });
    // Fallback về vi nếu có lỗi
    i18n.options.fallbackLng = 'vi';
    localStorage.setItem('selectedLanguageCode', 'vi');
    return { code: 'vi', name: 'Vietnamese', isDefault: true };
  }
};